export const MCP_CONNECTION_PROACTIVE_REQUIRED_MESSAGE =
  "Connections require an active Proactive subscription.";
export const MCP_CONNECTION_SYNC_FAILED_MESSAGE = "Mem couldn’t sync this connection.";
export const MCP_CONNECTION_OAUTH_INCOMPATIBLE_MESSAGE = "Mem can’t use this connection yet";
